/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmationlinkinvalid2Inputs */

const en_confirmationlinkinvalid2 = /** @type {(inputs: Confirmationlinkinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This confirmation link is invalid or has expired. Sign in with your password.`)
};

const de_confirmationlinkinvalid2 = /** @type {(inputs: Confirmationlinkinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bestätigungslink ist ungültig oder abgelaufen. Melde dich mit deinem Passwort an.`)
};

/**
* | output |
* | --- |
* | "This confirmation link is invalid or has expired. Sign in with your password." |
*
* @param {Confirmationlinkinvalid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmationlinkinvalid2 = /** @type {((inputs?: Confirmationlinkinvalid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmationlinkinvalid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmationlinkinvalid2(inputs)
	return de_confirmationlinkinvalid2(inputs)
});
export { confirmationlinkinvalid2 as "confirmationLinkInvalid" }